import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetDocumentListEmdRequest,
  failGetDocumentListEmd,
  setGetDocumentListEmd,
  setGetDocumentListEmdFromApi,
  updateGetDocumentListEmd,
  updateGetDocumentListEmdFromApi,
} from './get-document-list-emd.actions';

/**
 * Service to handle async GetDocumentListEmd actions
 */
@Injectable()
export class GetDocumentListEmdEffect {
  /**
   * Set the state with the reply content, dispatch failGetDocumentListEmd if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetDocumentListEmdFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetDocumentListEmd({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetDocumentListEmd({ error, requestId: action.requestId })),
        cancelGetDocumentListEmdRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetDocumentListEmd if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetDocumentListEmdFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetDocumentListEmd({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetDocumentListEmd({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
